import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import "../common/styles.scss";

Vue.use(VueRouter);

const getPath = p => {
  return `${p}(-de)?`;
};

const routes = [
  {
    path: "/(de)?",
    name: "Home",
    component: Home
  },
  {
    path: getPath("/project"),
    component: () => import("../views/steps/Project.vue")
  },
  {
    path: getPath("/home-type"),
    component: () => import("../views/steps/HomeType.vue")
  },
  {
    path: getPath("/home-size"),
    component: () => import("../views/steps/HomeSize.vue")
  },
  {
    path: getPath("/windows"),
    component: () => import("../views/steps/Windows.vue")
  },
  {
    path: getPath("/rooms"),
    component: () => import("../views/steps/Rooms.vue")
  },
  {
    path: getPath("/ambient-lights"),
    component: () => import("../views/steps/AmbientLights.vue")
  },
  {
    path: getPath("/buttons"),
    component: () => import("../views/steps/Buttons.vue")
  },
  {
    path: getPath("/displays"),
    component: () => import("../views/steps/Displays.vue")
  },
  {
    path: getPath("/music"),
    component: () => import("../views/steps/Music.vue")
  },
  {
    path: getPath("/voice-control"),
    component: () => import("../views/steps/VoiceControl.vue")
  },
  {
    path: getPath("/mobile-app"),
    component: () => import("../views/steps/MobileApp.vue")
  },
  {
    path: getPath("/remote-access"),
    component: () => import("../views/steps/RemoteAccess.vue")
  },
  {
    path: getPath("/intercom"),
    component: () => import("../views/steps/Intercom.vue")
  },
  {
    path: getPath("/alarm"),
    component: () => import("../views/steps/Alarm.vue")
  },
  {
    path: getPath("/cameras"),
    component: () => import("../views/steps/SecurityCameras.vue")
  },
  {
    path: getPath("/air-con"),
    component: () => import("../views/steps/AirCon.vue")
  },
  {
    path: getPath("/recuperation"),
    component: () => import("../views/steps/Recuperation.vue")
  },
  {
    path: getPath("/wiring"),
    component: () => import("../views/steps/TimeOfWiring.vue")
  },
  {
    path: getPath("/location"),
    component: () => import("../views/steps/Location.vue")
  },
  {
    path: getPath("/hazard"),
    component: () => import("../views/steps/Hazard.vue")
  },
  {
    path: getPath("/expectations"),
    component: () => import("../views/steps/Expectations.vue")
  },
  {
    path: getPath("/finish"),
    component: () => import("../views/Finish.vue")
  },
  {
    path: getPath("/summary"),
    component: () => import("../views/Summary.vue")
  },
  {
    path: getPath("/thank-you"),
    component: () => import("../views/ThankYou.vue")
  },
  // 404 - must be defined last to catch everything else
  { path: "*", component: () => import("../views/NotFound.vue") }
];

const router = new VueRouter({
  mode: "history",
  base: "smart-home/calculator/",
  routes
});

export default router;
